import { ePetitionDownloadQuery, useDownloadPoMutation } from '@gov-nx/api';
import type { OnEpetitionDownloadParams } from '@gov-nx/component/common';

export interface PetititionDownloadProps {
	onError?: (petitionId: number, error: Error) => void;
	onSuccess?: (data: OnEpetitionDownloadParams) => void;
}

export const usePetitionDownload = (props?: PetititionDownloadProps) =>
	useDownloadPoMutation(ePetitionDownloadQuery, {
		onError: (error, { petitionId }) => {
			if (props?.onError) {
				props.onError(petitionId, error);
			}
		},
		onSuccess: (data) => {
			if (props?.onSuccess) {
				props.onSuccess({
					antivirus: data.antivirus,
					fileName: data.fileName,
					blob: data.blob,
					petitionId: data.variables.petitionId,
				});
			}
		},
	});
